import { PropsWithChildren } from 'react';
import { Navigate } from 'react-router';
import { useFeatureFlag } from './hooks';
import { FlagsTypes } from './types';

export function RequireFlag({
  children,
  flag,
  redirectTo = '/'
}: PropsWithChildren<{
  redirectTo?: string;
  flag: keyof FlagsTypes;
}>): JSX.Element {
  const isFlagsEnable = useFeatureFlag(flag);
  if (isFlagsEnable) {
    return <>{children}</>;
  } else {
    return <Navigate to={redirectTo} />;
  }
}
